 //Clock Function --> MAK
window.onload=function () {
       const timeDisplay = document.getElementsByClassName('NYC');
        if(timeDisplay!==null){
            setInterval(function tick() {
            var str = " NYC"
        let nycDate = new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
          timeDisplay[0].innerText = nycDate + str
        }, 10);
      }
}

